/* @ngInject */
const myRadioButton = () => {
  return {
    restrict: 'E',
    scope: {
      myId: '=?',
      myLabel: '=?',
      myValue: '=?',
      ngModel: '=?',
      myClick: '&?',
      myTabindex: '=?',
    },

    template: require('./myRadioButton.html'),

    /* @ngInject */
    controller: ($scope) => {

    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myRadioButton



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/buttons/myRadioButton.js